import { render, staticRenderFns } from "./GuppyChatPostsConversationListItem.vue?vue&type=template&id=c2c12ada&scoped=true&"
import script from "./GuppyChatPostsConversationListItem.vue?vue&type=script&lang=js&"
export * from "./GuppyChatPostsConversationListItem.vue?vue&type=script&lang=js&"
import style0 from "./GuppyChatPostsConversationListItem.vue?vue&type=style&index=0&id=c2c12ada&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c12ada",
  null
  
)

export default component.exports